import React from 'react'
import PlayerHeader from './player-header'
import PlayersHeader from './players-header'

const Header = (props) => {
  const { query, setQuery, selectedPlayers, selectedPlayer } = props

  return <div className='messages-cell chat-header'>
    { !selectedPlayers && 
      <PlayerHeader
        query={query}
        setQuery={setQuery}
        selectedPlayer={selectedPlayer}
        onPickPlayer={props.onPickPlayer}
        onPickPlayers={props.onPickPlayers}
        onShowPlayer={props.onShowPlayer}
      />
    }
    { selectedPlayers && 
      <PlayersHeader
        selectedPlayers={selectedPlayers}
        setQuery={setQuery}
        onRemovePlayer={props.onRemovePlayer}
      />
    }
  </div>
}

export default Header

